import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const Home = ({ t }) => {
	return (
		<React.Fragment>
			<Box sx={{textAlign: 'center', marginTop: 6 }}>
				<SupportAgentIcon
					sx={{ fontSize: '110px', verticalAlign: 'middle', marginRight: '5px', textAlign: 'center', color: '#777' }}
				/>
			</Box>
			<Typography
				sx={{ fontSize: {xs: '1.5em', md: '2em'}, fontWeight: '500', textAlign: 'center' }}
				mt={4}
				mb={9}
			>
				{t('home:welcomeHeader')}
			</Typography>
		</React.Fragment>
	);
};

Home.propTypes = {
	t: PropTypes.func
};

export default withTranslation(['home', 'common'])(Home);
